"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetWorkflowBySalesOrder = GetWorkflowBySalesOrder;
exports.add = add;
exports.addCmsWordOrder = addCmsWordOrder;
exports.addContract = addContract;
exports.addContractFollow = addContractFollow;
exports.addSubcontract = addSubcontract;
exports.all = all;
exports.allotSelectUsers = allotSelectUsers;
exports.archiveContract = archiveContract;
exports.auditContract = auditContract;
exports.autoGenerateContractNo = autoGenerateContractNo;
exports.confirmPlan = confirmPlan;
exports.default = void 0;
exports.del = del;
exports.delContract = delContract;
exports.downloadOssFile = downloadOssFile;
exports.edit = edit;
exports.editContract = editContract;
exports.generateContractNo = generateContractNo;
exports.getContract = getContract;
exports.getContractFollowList = getContractFollowList;
exports.getContractList = getContractList;
exports.getContractMan = getContractMan;
exports.getCustFollowById = getCustFollowById;
exports.getCustFollowList = getCustFollowList;
exports.getCustInfo = getCustInfo;
exports.getWorkList = getWorkList;
exports.measure = measure;
exports.measured = measured;
exports.queryDealer = queryDealer;
exports.queryDealerShop = queryDealerShop;
exports.queryDealerShopByDealer = queryDealerShopByDealer;
exports.sizeVerified = sizeVerified;
exports.unArchiveContract = unArchiveContract;
exports.unAuditContract = unAuditContract;
exports.updateContractFollow = updateContractFollow;

require("core-js/modules/es6.array.sort");

var _request = _interopRequireDefault(require("@/utils/request"));

function all(rowId) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder?rowId=' + rowId,
    method: 'get'
  });
}

function add(data) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder',
    method: 'put',
    data: data
  });
}

function GetWorkflowBySalesOrder(SalesOrderGuid) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder/GetWorkflowBySalesOrderId?SalesOrderGuid=' + SalesOrderGuid,
    method: 'get'
  });
}

function addCmsWordOrder(data) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder/addCmsWordOrder',
    method: 'post',
    data: data
  });
}

function getWorkList(data) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder/getWorkList',
    method: 'post',
    data: data
  });
}

function getContract(contractNo) {
  return (0, _request.default)({
    url: 'api/contract?contractNo=' + contractNo,
    method: 'get'
  });
}

function getCustInfo(custId) {
  return (0, _request.default)({
    url: '/api/cust/queryCustInfo?custId=' + custId,
    method: 'get'
  });
}

function getContractMan(custId) {
  return (0, _request.default)({
    url: '/api/cust?custId=' + custId,
    method: 'get'
  });
}

function getCustFollowById(rowId) {
  return (0, _request.default)({
    url: '/api/custFollow/findById?rowId=' + rowId,
    method: 'get'
  });
}

function getCustFollowList(params) {
  return (0, _request.default)({
    url: '/api/custFollow',
    method: 'get',
    params: params
  });
}

function getContractList(params) {
  return (0, _request.default)({
    url: '/api/contract',
    method: 'get',
    params: params
  });
}

function addContract(data) {
  return (0, _request.default)({
    url: '/api/contract/addContract',
    method: 'post',
    data: data
  });
}

function editContract(data) {
  return (0, _request.default)({
    url: 'api/contract/edit',
    method: 'put',
    data: data
  });
}

function generateContractNo(params) {
  return (0, _request.default)({
    url: '/api/contract/generateContractNo',
    method: 'get',
    params: params
  });
}

function autoGenerateContractNo(params) {
  return (0, _request.default)({
    url: '/api/contract/autoGenerateContractNo',
    method: 'get',
    params: params
  });
}

function delContract(ids) {
  return (0, _request.default)({
    url: 'api/contract',
    method: 'delete',
    data: ids
  });
}

function archiveContract(id) {
  return (0, _request.default)({
    url: 'api/contract/archive',
    method: 'post',
    data: id
  });
}

function unArchiveContract(id) {
  return (0, _request.default)({
    url: 'api/contract/unArchive',
    method: 'post',
    data: id
  });
}

function auditContract(id) {
  return (0, _request.default)({
    url: 'api/contract/audit',
    method: 'post',
    data: id
  });
}

function unAuditContract(id) {
  return (0, _request.default)({
    url: 'api/contract/unAudit',
    method: 'post',
    data: id
  });
}

function addSubcontract(data) {
  return (0, _request.default)({
    url: 'api/contract/addSubcontract',
    method: 'post',
    data: data
  });
}

function allotSelectUsers(data) {
  return (0, _request.default)({
    url: 'api/contract/allotSelectUsers',
    method: 'post',
    data: data
  });
}

function measured(data) {
  return (0, _request.default)({
    url: 'api/contract/measured',
    method: 'post',
    data: data
  });
}

function measure(data) {
  return (0, _request.default)({
    url: 'api/contract/measure',
    method: 'post',
    data: data
  });
}

function sizeVerified(data) {
  return (0, _request.default)({
    url: 'api/contract/sizeVerified',
    method: 'post',
    data: data
  });
}

function confirmPlan(data) {
  return (0, _request.default)({
    url: 'api/contract/confirmPlan',
    method: 'post',
    data: data
  });
}

function getContractFollowList(params) {
  var url = 'api/contractFollow/all';

  if (params) {
    var queryParams = [];

    if (params.rowId) {
      queryParams.push("rowId=".concat(params.rowId));
    }

    if (params.contractId) {
      queryParams.push("contractId=".concat(params.contractId));
    }

    if (params.sort) {
      queryParams.push("sort=".concat(params.sort));
    }

    if (queryParams.length > 0) {
      url += "?".concat(queryParams.join('&'));
    }
  }

  return (0, _request.default)({
    url: url,
    method: 'get'
  });
}

function addContractFollow(data) {
  return (0, _request.default)({
    url: 'api/contractFollow',
    method: 'post',
    data: data
  });
}

function updateContractFollow(data) {
  return (0, _request.default)({
    url: 'api/contractFollow',
    method: 'put',
    data: data
  });
}

function queryDealerShop() {
  return (0, _request.default)({
    url: '/api/contract/queryDealerShop',
    method: 'get'
  });
}

function queryDealer() {
  return (0, _request.default)({
    url: '/api/contract/queryDealer',
    method: 'get'
  });
}

function queryDealerShopByDealer(dealerCode) {
  return (0, _request.default)({
    url: '/api/contract/queryDealerShopByDealer',
    method: 'get',
    params: {
      dealerCode: dealerCode
    }
  });
}

function downloadOssFile(params) {
  return (0, _request.default)({
    url: '/api/oss/download',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

var _default = {
  all: all,
  add: add,
  edit: edit,
  del: del,
  getWorkList: getWorkList,
  getCustInfo: getCustInfo,
  addCmsWordOrder: addCmsWordOrder,
  getCustFollowById: getCustFollowById,
  getCustFollowList: getCustFollowList,
  getContractList: getContractList,
  addContract: addContract,
  editContract: editContract,
  generateContractNo: generateContractNo,
  delContract: delContract,
  addSubcontract: addSubcontract,
  allotSelectUsers: allotSelectUsers,
  measured: measured,
  measure: measure,
  sizeVerified: sizeVerified,
  confirmPlan: confirmPlan,
  getContractFollowList: getContractFollowList,
  addContractFollow: addContractFollow,
  updateContractFollow: updateContractFollow,
  queryDealerShop: queryDealerShop,
  downloadOssFile: downloadOssFile,
  queryDealer: queryDealer,
  queryDealerShopByDealer: queryDealerShopByDealer
};
exports.default = _default;